import * as React from 'react';
import {FunctionComponent} from 'react';
import {CalendarEvent} from '../../../../../../Models/CalendarEvent';
import {FullCrew} from '../../../../../../Models/Crew';
import {RsvpResponseCell} from '../../RsvpResponseCell/RsvpResponseCell';
import {RsvpCalendarHeader} from './RsvpCalendarHeader';

interface OwnProps {
    crew: FullCrew;
    calendarEvents: CalendarEvent[];
    onCalendarEventClick: (calendarEvent: CalendarEvent) => void;
}

export const CrewRsvpCalendar: FunctionComponent<OwnProps> = ({crew, calendarEvents, onCalendarEventClick}) => {
    const filteredCalendarEvents = calendarEvents.filter((calendarEvent) => {
        return calendarEvent.crewId === crew.id;
    });

    return (
        <div className="calendar-rsvp">
            <div className="calendar-rsvp__row calendar-rsvp__row--with-borders">
                <div className="calendar-rsvp__cell" />
                {filteredCalendarEvents.map((calendarEvent) => (
                    <RsvpCalendarHeader
                        key={calendarEvent.scheduledEventId + '|' + calendarEvent.startAt.getTime()}
                        calendarEvent={calendarEvent}
                        onCalendarEventClick={onCalendarEventClick}
                    />
                ))}
            </div>
            {crew.members.map((member) => {
                const userId = member.userId;
                return (
                    <div key={member.userId} className="calendar-rsvp__row">
                        <div key="member" className="calendar-rsvp__cell calendar-rsvp__member">
                            {member.firstName} {member.lastName}
                        </div>
                        {userId !== null &&
                            filteredCalendarEvents.map((calendarEvent, index) => {
                                return (
                                    <div
                                        key={calendarEvent.scheduledEventId + '|' + calendarEvent.startAt.getTime()}
                                        className="calendar-rsvp__cell"
                                    >
                                        <RsvpResponseCell interactive userId={userId} calendarEvent={calendarEvent} />
                                    </div>
                                );
                            })}
                    </div>
                );
            })}
        </div>
    );
};
